<div class="favorite-menu-wrapper">
  <h1 class="page-title mb-0">
    <span class="icon">
      <i class="fa-solid fa-heart" aria-hidden="true"></i>
    </span>
    {{ "Menu.Title.UserFavoriteMenu" | translate }}
  </h1>
  <span class="mb-2">{{ "Menu.Message.PleaseRefresh" | translate }}</span>
  <!-- 分欄區域 -->
  <div class="multi-column-container mt-2">
    <div class="menu-block" *ngFor="let menuResp of userFavoriteMenus let i = index">
      <!-- 類別標題 -->
      <div class="flex items-center justify-between mb-2">
        <div class="flex items-center gap-2">
          <i class="{{ menuResp.parentMenu.icon }} parent-icon"></i>
          <span class="parent-text">{{ menuResp.parentMenu.label }}</span>
        </div>
        <button
          pButton
          type="button"
          [icon]="
            menuResp.parentMenu.favorite
              ? 'fa-solid fa-heart'
              : 'fa-regular fa-heart'
          "
          class="heart-button p-button-sm p-button-text p-button-rounded p-button-icon-only"
          [ngClass]="{ 'animate-favorite': menuResp.parentMenu.animate }"
          [pTooltip]="
            menuResp.parentMenu.favorite
              ? ('Menu.Message.DeselectAll' | translate)
              : ('Menu.Message.SelectAll' | translate)
          "
          tooltipPosition="right"
          (click)="toggleCategoryFavorite(menuResp)"
        ></button>
      </div>

      <!-- 子選單 -->
      <ul class="list-none p-0 m-0">
        <li
          *ngFor="let subMenu of menuResp.subMenuList"
          class="flex items-center justify-between hover:bg-gray-100 rounded"
        >
          <div class="flex items-center gap-2">
            <a
              class="text text-link"
              *ngIf="subMenu.routerLink"
              [routerLink]="subMenu.routerLink"
            >
              {{ subMenu.label }}
            </a>
            <a
              class="text text-link"
              *ngIf="subMenu.url"
              [href]="subMenu.url"
              target="_blank"
            >
              {{ subMenu.label }}
            </a>
          </div>
          <button
            pButton
            type="button"
            [icon]="
              subMenu.favorite ? 'fa-solid fa-heart' : 'fa-regular fa-heart'
            "
            class="heart-button p-button-sm p-button-text p-button-rounded p-button-icon-only"
            [ngClass]="{ 'animate-favorite': subMenu.animate }"
            [pTooltip]="
              subMenu.favorite
                ? ('Menu.Message.RemoveFavorite' | translate)
                : ('Menu.Message.AddFavorite' | translate)
            "
            tooltipPosition="right"
            (click)="toggleSubMenuFavorite(subMenu)"
          ></button>
        </li>
      </ul>
    </div>
  </div>
</div>
